import React from "react";
import { Table, Collapse } from "reactstrap";
import { object } from "prop-types";
import "./LinkedClientsTable.css";

import AllClientDetails from "../all-client-details/AllClientDetails";
import { useDispatch, useSelector } from "react-redux";
import { singleClientReportLinkedClientsExpandedRowsSelector } from "../../../selectors";
import { setExpandedRowsLinkedClientsSingleClientReport } from "../../../actions";
import { PlusExpand } from "../../../../../assets";
import { getRiskColor } from "../../../../../utilities/riskColor";

const LinkedClientsTable = ({ singleClientReportDetails }) => {
  const dispatch = useDispatch();
  const expandedRows = useSelector(
    singleClientReportLinkedClientsExpandedRowsSelector
  );

  const handleExpand = (player) => {
    let tempExpandedRows = [...expandedRows];
    let idxFound = tempExpandedRows.findIndex((id) => {
      return id === player.id;
    });

    if (idxFound > -1) {
      tempExpandedRows.splice(idxFound, 1);
    } else {
      tempExpandedRows.push(player.id);
    }

    dispatch(
      setExpandedRowsLinkedClientsSingleClientReport([...tempExpandedRows])
    );
  };

  const isExpanded = (player) => {
    const idx = expandedRows.find((id) => {
      return id === player.id;
    });

    return idx > -1;
  };

  const getRows = (entry) => {
    let rows = [];

    const riskStyle = () =>
      entry.riskClass ? { color: getRiskColor({ key: entry.riskClass }) } : {};

    const classNamesTD = () =>
      isExpanded(entry)
        ? "td-background-transition td-background-color"
        : "td-background-transition";

    const firstRow = (
      <tr>
        <td width={300} class={classNamesTD()}>
          {entry.clientName}
        </td>
        <td width={150} class={classNamesTD()}>
          {entry.clientType}
        </td>
        <td width={500} class={classNamesTD()}>
          {entry.riskClass !== "Normal risk level"
            ? entry.scoreValueOfEachParameter
                .filter((a) => a.scoreCardRiskProfileName === entry.riskClass)
                .map((a) => a.scoreCardRiskFactorName)
                .join(" , ")
            : ""}
        </td>
        <td style={riskStyle()} class={classNamesTD()}>
          {entry.riskClass}
        </td>
        <td width={30} class={classNamesTD()}>
          <span
            className={
              isExpanded(entry)
                ? "button-expand-table  button-expand-table-expanded"
                : "button-expand-table "
            }
            onClick={() => handleExpand(entry)}
          >
            <PlusExpand
              className={
                isExpanded(entry)
                  ? "button-collapse-icon  button-collapse-tables-rotate"
                  : "button-collapse-icon"
              }
            />
          </span>
        </td>
      </tr>
    );

    rows.push(firstRow);

    entry.params = {};
    entry.params.id = entry.id;

    const projectRows = (
      <tr>
        <td colSpan={6} className="p-0 border-bottom-0 border-light ">
          <Collapse className="pt-2" isOpen={expandedRows.includes(entry.id)}>
            <AllClientDetails
              singleClientReportDetails={entry}
              showCompanyDetails={true}
            />
          </Collapse>
        </td>
      </tr>
    );
    rows.push(projectRows);

    return rows;
  };

  const getTable = (clients) => {
    const rows = clients.map((client) => {
      return getRows(client);
    });

    return (
      <Table>
        <thead>
          <tr>
            <th class="linkedclients">
              {singleClientReportDetails.clientNameLabel}
            </th>
            <th class="linkedclients">
              {singleClientReportDetails.clientTypeLabel}
            </th>
            <th class="linkedclients">
              {singleClientReportDetails.riskFactorLabel}
            </th>
            <th class="linkedclients">
              {singleClientReportDetails.riskClassLabel}
            </th>
            <th class="linkedclients"></th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
        <tfoot
          className="foot-common-risk"
          style={{
            backgroundColor: getRiskColor({
              key: singleClientReportDetails.commonRiskLevel,
            }),
          }}
        >
          <th>
            <div>{singleClientReportDetails.commonRiskLevelLabel}</div>
          </th>
          <th></th>
          <th></th>
          <th>
            <div>{singleClientReportDetails.commonRiskLevel}</div>
          </th>
          <th></th>
        </tfoot>
      </Table>
    );
  };

  if (
    singleClientReportDetails.linkedClients.filter(
      (a) => a.id === singleClientReportDetails.id
    ).length === 0
  ) {
    singleClientReportDetails.linkedClients = [
      singleClientReportDetails,
      ...singleClientReportDetails.linkedClients,
    ];
  }

  return <div>{getTable(singleClientReportDetails.linkedClients)}</div>;
};
LinkedClientsTable.propTypes = {
  singleClientReportDetails: object.isRequired,
};

export default LinkedClientsTable;



// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/linked-clients-details/LinkedClientsTable.jsx